import React from 'react';

import { DropdownMenuType } from 'ui-components/components/dropdown-menu/dropdown-menu-type';

import { CSWFieldId, getOrderDetailsFieldId } from '../../../../../constants/field-ids';
import FulfillmentServiceContainer from '../../../../../fulfillment-planner/fulfillment-service/container';
import { ShippingServiceLabel } from '../../../shared-field-labels/shared-field-labels';
import LabeledField from '../labeled-field';

const fieldId = getOrderDetailsFieldId(CSWFieldId.ExternalFulfillmentService);

export const ExternalFulfillmentService = () => {
  return (
    <LabeledField label={ShippingServiceLabel} labelFor={fieldId}>
      <FulfillmentServiceContainer dropdownMenuType={DropdownMenuType.ComboBox} id={fieldId} />
    </LabeledField>
  );
};
